import React from "react";
import {

} from "@mui/material";
import {
  makeStyles
} from "@mui/styles";
import {getImage} from "../../../../../utils/image";

const ServiceInfo = ({ title, iconId }) => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <div className={classes.icon}>
        <img src={getImage(iconId, {width: 48, height: 48})}/>
      </div>
      <div>
        <div className={classes.name}>{ title }</div>
      </div>
    </div>
  )
}

const useStyles = makeStyles(theme => ({
  root: {
    display: "flex",
    marginTop: "-12px",
    padding: "8px 12px",
    alignItems: "center",
    boxSizing: "border-box",
    borderRadius: "0 0 12px 12px",
    background: theme.palette.header.default,
  },
  icon: {
    width: 36, height: 36, marginRight: "12px",
    "& img": {
      objectFit: "contain",
      objectPosition: "50% 50%",
      width: "100%", height: "100%",
    }
  },
  name: {
    fontSize: 16,
    fontWeight: "500",
    lineHeight: "20px",
    color: theme.palette.text.primary,
  },
}));
export default ServiceInfo
